import React from 'react';

var SvgCartAbandonedFilledIcon = function SvgCartAbandonedFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.75a.75.75 0 0 1 .75-.75h1.612a1.75 1.75 0 0 1 1.732 1.5h9.656a.75.75 0 0 1 .748.808l-.358 4.653a2.75 2.75 0 0 1-2.742 2.539h-6.351l.093.78a.25.25 0 0 0 .248.22h6.362a.75.75 0 0 1 0 1.5h-6.362a1.75 1.75 0 0 1-1.738-1.543l-1.04-8.737a.25.25 0 0 0-.248-.22h-1.612a.75.75 0 0 1-.75-.75Zm6.708 2.458a.625.625 0 0 0 0 .884l1.408 1.408-1.408 1.408a.625.625 0 1 0 .884.884l1.408-1.408 1.408 1.408a.625.625 0 1 0 .884-.884l-1.408-1.408 1.408-1.408a.625.625 0 0 0-.884-.884l-1.408 1.408-1.408-1.408a.625.625 0 0 0-.884 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }));
};
SvgCartAbandonedFilledIcon.displayName = "CartAbandonedFilledIcon";

export { SvgCartAbandonedFilledIcon as S };
